'use client'

import { SelectBox } from '@components/primitives/SelectBox/SelectBox.client'
import { Text } from '@components/primitives/Text'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import type { ConceptsByFrequency } from '@modules/trials/helpers/extractEntitiesFromEligibilityCriteria/types'

export function SearchInput({
  itemsByFrequencyCollection,
  menuPlacement = 'top',
  onChange,
  placeholder,
  searchTitle,
  trackingType,
  value,
  valueDisplayCallback = (s) => s,
}: {
  itemsByFrequencyCollection: ConceptsByFrequency
  menuPlacement?: 'auto' | 'bottom' | 'top'
  onChange?: (newValue: string[]) => void
  placeholder?: string
  searchTitle: string
  trackingType: string
  value?: string[]
  valueDisplayCallback?: (value: string) => string
}) {
  const selectedItems = value ?? []

  const updateSelectedItems = (item?: string) => {
    if (!item) return

    const newValue = Array.from(new Set([...selectedItems, item]))
    if (onChange) {
      onChange(newValue)
    }
    trackEvent(TrackingEvents.TRIAL_APPLICATION_SEARCH_ITEM_SELECTED, {
      source: TrackingSources.APPLY_FLOW_V2,
      type: trackingType,
      val: item,
    })
  }

  return (
    <div className='relative flex flex-col gap-0'>
      <Text
        className='pb-2 text-neutral900'
        element={'p'}
        styleName='p-small'
        value={searchTitle}
      />
      <SelectBox
        instanceId='searchable-input'
        items={itemsByFrequencyCollection.map((item) => ({
          label: valueDisplayCallback(item.name),
          value: item.name,
        }))}
        menuPlacement={menuPlacement}
        onChange={updateSelectedItems}
        placeholder={placeholder ?? 'Search'}
        value={undefined} // this is always a searchbox, so no value
      />
    </div>
  )
}
